export default "\n  {{title}}\n\n";